<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <datos-trabajo></datos-trabajo>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import DatosTrabajo from '@/components/forms/DatosTrabajo'
  export default {
    name: 'TrabajoPage',
    components: {DatosTrabajo}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/information/TrabajoPage.vue